import React from "react";

// 1. KOMPONEN TOTAL HARGA
export const InvoiceTotals = ({ data, header }) => {
  const additionalCharges = JSON.parse(header.additional_charges || "[]");
  const deductions = JSON.parse(header.deductions || "[]");

  const subTotal = data.reduce((sum, item) => sum + (item.base_price || 0), 0);
  
  const fscPercent = header.fsc_percent || 0;
  const fscTotal = Math.round(subTotal * (fscPercent / 100));

  const totalAdditional = additionalCharges.reduce((sum, item) => sum + (item.amount || 0), 0);
  
  const totalBeforeVat = subTotal + fscTotal + totalAdditional;

  const vatPercent = parseFloat(header.vat_percent) || 0;
  const calculatedVat = Math.trunc(totalBeforeVat * (vatPercent / 100));
  const vatOverride = data.reduce((sum, item) => sum + (parseFloat(item.vat_amount) || 0), 0);
  const vatTotal = vatOverride > 0 ? Math.round(vatOverride) : calculatedVat;

  const totalDeductions = deductions.reduce((sum, item) => sum + (item.amount || 0), 0);
  const grandTotal = totalBeforeVat + vatTotal - totalDeductions;

  const formatRp = (num) => {
    return new Intl.NumberFormat('id-ID', { minimumFractionDigits: 0 }).format(num);
  };
    
  return (
    <div className="flex justify-end mt-2 text-xs font-sans text-black">
        <div className="w-[50%]">
            <div className="border-t border-black mb-2"></div>
            <div className="flex justify-between mb-1">
                <span>Sub Total</span>
                <span className="font-bold text-right">Rp. {formatRp(subTotal)}</span>
            </div>
            <div className="flex justify-between mb-1">
                <span>Fuel Surcharge ({fscPercent}%)</span>
                <span className="text-right">Rp. {formatRp(fscTotal)}</span>
            </div>

            {additionalCharges.map((item, index) => (
                <div key={index} className="flex justify-between mb-1">
                    <span>{item.desc || 'Additional Charge'}</span>
                    <span className="text-right">Rp. {formatRp(item.amount)}</span>
                </div>
            ))}

            {/* Total DPP - garis hitam tebal di atas */}
            <div className="flex justify-between mb-1 font-bold border-t-2 border-black pt-1">
                <span>Total</span>
                <span className="text-right">Rp. {formatRp(totalBeforeVat)}</span>
            </div>
            
            <div className="flex justify-between mb-1 leading-relaxed">
                <span>VAT ({vatPercent}%)</span>
                <span className="text-right">Rp. {formatRp(vatTotal)}</span>
            </div>

            {deductions.map((item, index) => (
                <div key={index} className="flex justify-between mb-1 text-black">
                    <span>Deduction {item.desc ? `(${item.desc})` : ''}</span>
                    <span className="text-right">Rp. ( {formatRp(item.amount)} )</span>
                </div>
            ))}
            
            {/* Grand Total - hanya garis atas, tidak ada garis bawah */}
            <div className="flex justify-between mt-4 pt-2 border-t-2 border-black font-bold text-sm">
                <span>GRAND TOTAL</span>
                <span className="text-right">Rp. {formatRp(grandTotal)}</span>
            </div>
        </div>
    </div>
  );
};

// 2. KOMPONEN BANK & TANDA TANGAN
export const InvoiceBankSignature = () => {
    return (
        <div className="text-xs font-sans border-t border-gray-400 pt-4 flex justify-between items-end">
            <div className="w-[60%] text-[10px] leading-snug">
                <p className="font-bold mb-1">Account transfer: PT. SAYAP BIRU EKSPRES</p>
                <ul className="list-none space-y-1">
                    <li>• <span className="font-bold">Bank Mizuho Indonesia</span> - A/C: 319426-0151 (IDR)</li>
                    <li>• <span className="font-bold">MUFG Bank, Ltd.</span> - A/C: 5100003427 (IDR)</li>
                    <li>• <span className="font-bold">Bank Permata</span> - A/C: 0122 3676 533 (IDR)</li>
                </ul>
                <p className="mt-2 italic text-black font-bold">
                    All Cheques should be crossed "A/C payee Only" and made payable to PT. SAYAP BIRU EKSPRES
                </p>
            </div>
            <div className="w-[30%] text-center">
                <p className="font-bold mb-24">PT. SAYAP BIRU EKSPRES</p>
                <div className="border-b border-black w-full"></div>
                <p className="text-[10px] mt-1 italic">Authorized Signature</p>
            </div>
        </div>
    );
};